export const REGION = process.env.REACT_APP_REGION
export const CDN_URL = process.env.REACT_APP_CDN_URL
export const COGNITO_IDENTITY_POOL_ID =
  process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
export const COGNITO_POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID
export const COGNITO_POOL_WEB_CLIENT_ID =
  process.env.REACT_APP_COGNITO_POOL_WEB_CLIENT_ID
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT
export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET
